import { checkoutStore } from '~/stores';
import { SlotDeliveryDetails } from '~/stores/CheckoutStore/Delivery';

export const getSlotsChangedEventKey = (
  delivery?: SlotDeliveryDetails,
): string =>
  delivery ? `${delivery.scheduleSlotId}${delivery.currentDate}` : 'express';

export const useSlotsChangedEvent = () => {
  const { slotsChangedEventStore } = checkoutStore;

  const handleCloseModal = () => {
    slotsChangedEventStore.closeModal();
  };

  return {
    slotsChangedEventStore,
    handleCloseModal,
    getKey: getSlotsChangedEventKey,
  };
};
